"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compilerProfile = void 0;
exports.compilerProfile = {
    name: 'solidity',
    methods: ['compile', 'getCompilationResult', 'compileWithParameters', 'setCompilerConfig'],
    events: ['compilationFinished']
};
//# sourceMappingURL=profile.js.map